import { useEffect, useState } from 'react';
import { userApi } from '../generated/clients';
import { UserDTO } from '../generated';

export function useUser(userId?: string): [UserDTO | undefined, string | undefined, () => void] {
  const [user, setUser] = useState<UserDTO>();
  const [error, setError] = useState<string>();

  const loadUser = async (id: string) => {
    try {
      const user = await userApi.userGetUserById({ id });
      setUser(user);
      setError(undefined);
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
      }
    }
  };

  useEffect(() => {
    if (userId) loadUser(userId);
  }, [userId]);

  return [user, error, () => loadUser(userId ?? '')];
}
